<script setup lang="ts">
import AppLoader from '@/components/layout/AppLoader.vue'
import { useAuthStore } from '@/stores/auth.store'

const authStore = useAuthStore()
</script>

<template>
  <RouterView />
  <Transition name="app-loader-fade">
    <AppLoader v-if="!authStore.sessionLoaded" />
  </Transition>
</template>

<style>
.app-loader-fade-leave-active {
  transition: opacity 340ms var(--ease-standard);
}

.app-loader-fade-leave-to {
  opacity: 0;
}
</style>
